import React from "react";
import "./Home.css";

const HeroBanner = () => {
  return (
    <section className="hero">
      {/* Background video */}
      <video
        className="hero__video"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"   /* fallback image while loading */
      >
        <source src="/hero2.mp4" type="video/mp4" />
        {/* Optional webm for better compression */}
        {/* <source src="/assets/hero.webm" type="video/webm" /> */}
      </video>

      

      {/* NHS badge */}
      <img
        className="hero__nhs"
        src="/council.png"
        alt="NHS"
      />

      {/* Text content */}
      <div className="hero__content">
        <h1 className="hero__title">
          CarePlus Homes
        </h1>
        <p className="hero__desc">
          We provide high-quality residential care for children and young people. Our team of trained professionals is committed to ensuring every child feels valued, supported, and empowered to reach their full potential.
        </p>
      </div>
    </section>
  );
};

export default HeroBanner;
